import { useEffect, useState, useCallback } from 'react';
import { api } from '../api/client';

let cache = null;
let pending = null;
const subscribers = new Set();

async function load() {
  if (cache) return cache;
  if (pending) return pending;
  pending = (async () => {
    try {
      const s = await api.getSettings();
      let texts = {};
      try {
        const raw = s.site_texts_json;
        if (raw) texts = typeof raw === 'string' ? JSON.parse(raw) : raw;
      } catch { /* invalid json, use empty */ }
      cache = texts;
      subscribers.forEach((cb) => cb(cache));
      return cache;
    } catch {
      cache = {};
      subscribers.forEach((cb) => cb(cache));
      return cache;
    } finally {
      pending = null;
    }
  })();
  return pending;
}

export function clearTextCache() { cache = null; }

/** Hook per leggere una singola stringa con fallback. */
export function useSiteText(key, fallback = '') {
  const [val, setVal] = useState(() => (cache?.[key] ?? fallback));
  useEffect(() => {
    let alive = true;
    const update = (m) => { if (alive) setVal(m?.[key] ?? fallback); };
    if (cache) update(cache); else load().then(update);
    subscribers.add(update);
    return () => { alive = false; subscribers.delete(update); };
  }, [key, fallback]);
  return val;
}

/** Hook per ricevere l'intera mappa testi (uso admin). */
export function useSiteTexts() {
  const [map, setMap] = useState(() => cache || {});
  useEffect(() => {
    const update = (m) => setMap({ ...(m || {}) });
    if (cache) update(cache); else load().then(update);
    subscribers.add(update);
    return () => subscribers.delete(update);
  }, []);
  const refresh = useCallback(async () => { cache = null; const m = await load(); return m; }, []);
  return { map, refresh };
}

/** Setter usato dall'editor admin dopo il salvataggio. */
export function pushTexts(newMap) {
  cache = { ...(cache || {}), ...(newMap || {}) };
  subscribers.forEach((cb) => cb(cache));
}
